<template>
  <div class="journey-loading">
    <div class="loading-header">
      <i class="character"></i>
      <div class="loading--wrap">
        <i class='loading-bar'></i>
        <i class='loading-bar'></i>
        <i class='loading-bar'></i>
        <i class='loading-bar'></i>
        <i class='loading-bar'></i>
      </div>
      {{ $t('common.loadingDot') }}
    </div>
    <div class="loading-body">
      <span class="tip">Tip!</span>
      <div class="loading-content page" :class="[$i18n.locale]">
        <div class="loading-content-wrap">
          <h4 class="title" v-html="$t(`journey.mostOccurred.loading.title`)"></h4>
          <div class="image"></div>
          <div class="text">
            <p v-html="$t(`journey.mostOccurred.loading.description`)"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MostOccurredLoading'
}
</script>

<style lang="scss" scoped>
.journey-loading {
  width: 600px;
  height: 600px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;

  .loading-header {
    font-size: 15px;
    font-weight: 500;
    text-align: center;
    color: #ec0047;

    .character {
      width: 109px;
      height: 111px;
      display: block;
      margin: 46px auto 20px;
      background-image: url(../../assets/img/journey/loading-character.svg?url);
      background-size: 100% 100%;
      background-position: center;
    }

    .loading--wrap {
      width: 180px;
      height: 12px;
      margin: 20px auto 17px;

      .loading-bar {
        display: block;
        position: absolute;
        padding: 6px;
        border-radius: 50%;
        background-color: $brandColor;
        animation: loading 1.4s ease-in-out 0s infinite;

        &:nth-child(1) {
          animation-delay: 0s;
        }

        &:nth-child(2) {
          animation-delay: 0.15s;
        }

        &:nth-child(3) {
          animation-delay: 0.3s;
        }

        &:nth-child(4) {
          animation-delay: 0.45s;
        }

        &:nth-child(5) {
          animation-delay: 0.6s;
        }
      }
    }
  }

  .loading-body {
    width: 550px;
    height: 328px;
    border-radius: 6px;
    background-color: #1b1b1d;
    margin: 25px 25px 12px 25px;
    position: relative;

    .tip {
      font-size: 12px;
      color: #ffffff;
      border-radius: 2px;
      background-color: #43b6c9;
      padding: 4px 6px;
      position: absolute;
      top: 6px;
      left: 6px;
    }

    .loading-content {
      position: relative;
      height: 100%;

      .loading-content-wrap {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      .title {
        font-size: 18px;
        line-height: 1.33;
        color: #ffcf00;
        text-align: center;
      }

      .image {
        margin: 0 auto;
        background-size: contain;
        border-radius: 5px;
      }

      .text {
        p {
          font-size: 14px;
          line-height: 1.57;
          text-align: center;
          color: #bbbbbb;
        }
      }

      &.page {
        .image {
          width: 510px;
          height: 211px;
          background-image: url(../../assets/img/journey/loading/loading_most_occurred_en.png);
        }

        &.ko {
          .image {
            background-image: url(../../assets/img/journey/loading/loading_most_occurred_ko.png);
          }
        }

        &.ja {
          .image {
            background-image: url(../../assets/img/journey/loading/loading_most_occurred_ja.png);
          }
        }
      }
    }
  }
}

@keyframes loading {
  0% {
    transform: translateX(-15px);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateX(180px);
    opacity: 0;
  }
}
</style>
